import React, { useState, useEffect } from "react";
import {Button, message } from 'antd';
import ConnectWalletPopup from "./ConnectWalletPopup";
import copyIcon from "../img/copyIcon.png";
import "./css/WalletButton.less";
import { useDispatch,useSelector } from 'react-redux'
import { loginReducer } from '../store/userReducer'
import useGetUserInfo from '../hooks/useGetUserInfo'
import { useTranslation } from "react-i18next";

const WalletButton = () => {
  const { t, i18n }: { t: any,i18n:any } = useTranslation();
  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [walletAddress, setWalletAddress] = useState(null);
  const [isConnecting, setIsConnecting] = useState(false);
  const [isShowLogOut, setIsShowLogOut] = useState(false);
  const [isShowPop, setIsShowPop] = useState(false);
  const dispatch = useDispatch();
  const { username, nickname } = useGetUserInfo()

  useEffect(() => {
    checkWalletConnection();
    if ((window as any).ethereum) {
      (window as any).ethereum.on("accountsChanged", handleAccountsChanged);
      return () => {
        (window as any).ethereum.removeListener("accountsChanged", handleAccountsChanged);
      };
    }
  }, []);

  useEffect(() => {
    if (username) {
      setIsWalletConnected(true)
    }
  }, [username])

  const checkWalletConnection = async () => {
    const storedAddress = localStorage.getItem("address");
    if (storedAddress) {
      setWalletAddress(storedAddress);
      setIsWalletConnected(true);
      dispatch(loginReducer({ 'username':storedAddress, 'nickname':'OK' }))
    } else if ((window as any).ethereum) {
      try {
        const accounts = await (window as any).ethereum.request({ method: "eth_accounts" });
        if (accounts.length > 0) {
          setWalletAddress(accounts[0]);
          setIsWalletConnected(true);
          dispatch(loginReducer({ 'username':accounts[0], 'nickname':'OK' }))
        }
      } catch (error) {
        console.error("检查钱包连接状态失败:", error);
      }
    }
  };

  const connectWallet = async () => {
    if (!(window as any).ethereum) {
      alert("请安装 MetaMask");
      return;
    }
    if (isConnecting) return;
    setIsConnecting(true);
    try {
      const accounts = await (window as any).ethereum.request({ method: "eth_requestAccounts" });
      setWalletAddress(accounts[0]);
      setIsWalletConnected(true);
      localStorage.setItem("address", accounts[0]);
      dispatch(loginReducer({ 'username':accounts[0], 'nickname':'OK' }))
      setIsShowPop(false)
    } catch (error) {
      console.error("钱包连接错误:", error);
    } finally {
      setIsConnecting(false);
    }
  };

  const disconnectWallet = async () => {
    setWalletAddress(null);
    setIsWalletConnected(false);
    setIsShowLogOut(false);
    localStorage.removeItem("address");
    localStorage.removeItem("chanIndex");
    try {
      await (window as any).ethereum.request({ method: "wallet_revokePermissions", params: [{ eth_accounts: {} }] });
      console.log("权限已撤销，钱包完全断开");
      dispatch(loginReducer({ 'username':'', 'nickname':'' }))
    } catch (error) {
      console.error("撤销权限失败:", error);
    }
  };

  const handleAccountsChanged = (accounts) => {
    if (accounts.length === 0) {
      disconnectWallet();
    } else {
      setWalletAddress(accounts[0]);
      dispatch(loginReducer({ 'username':accounts[0], 'nickname':'OK' }))
    }
  };

  const copyAddress = async () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(walletAddress);
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = walletAddress
      textarea.style.position = 'absolute';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
    message.success(`Replicating Success`);
  };

  return (
    <div className="relative walletB" onMouseLeave={() => setTimeout(() => setIsShowLogOut(false), 200)}>
      <button
        onClick={() => (isWalletConnected ? setIsShowLogOut(true) : setIsShowPop(true))}
        style={{
            width: '120px',
            height: '40px',
            fontSize: '14px',
            cursor: 'pointer',
            color: isWalletConnected ? '#ffffff' : '',
            border: isWalletConnected ? '1px solid #ffffff1a' : '',
            backgroundColor: isWalletConnected ? '#ffffff0d' : '#ffffff',
            borderRadius: '20px' // Vue 的 `round` 对应 `borderRadius`
        }}
        >
        {!isWalletConnected
            ? t('It49')
            : `${walletAddress.substring(0, 6)}...${walletAddress.substring(walletAddress.length - 4)}`}
        </button>

        {isShowLogOut && (
        <div className="logOutPop">
            <div>
            <span></span>
            <div>
                {!isWalletConnected
                ? '链接钱包'
                : `${walletAddress.substring(0, 6)}...${walletAddress.substring(walletAddress.length - 4)}`}
            </div>
            <img src={copyIcon} alt="" onClick={copyAddress} />
            </div>
            <div onClick={disconnectWallet}>Log out</div>
        </div>
        )}

      {isShowPop && <ConnectWalletPopup onClose={() => setIsShowPop(false)} onConnect={connectWallet} />}
    </div>
  );
};

export default WalletButton;
